import { runInAction } from "mobx";
import { ActionType, Position, Rect } from "../Types";
import { canvasDispatch } from "./CanvasDispatch";
import { canvasLayoutIdAtom, sandboxLayoutOverrideBox } from "./CanvasState";
import { MAGIC_LAYOUT_ID } from "./SandboxConstants";

export const paneMutator = {
  updatePosition(paneId: string, position: Position) {
    const sandboxLayoutOverride = sandboxLayoutOverrideBox.get();
    if (sandboxLayoutOverride !== undefined) {
      runInAction(() => {
        sandboxLayoutOverride[paneId].rect = [
          ...position,
          sandboxLayoutOverride[paneId].rect[2],
          sandboxLayoutOverride[paneId].rect[3],
        ];
      });
      return;
    }
    const layoutId = canvasLayoutIdAtom.value;
    if (layoutId === MAGIC_LAYOUT_ID) {
      return;
    }
    if (layoutId !== undefined) {
      canvasDispatch([
        ActionType.SetLayoutPanePosition,
        { layoutId, paneId, position },
      ]);
    } else {
      canvasDispatch([ActionType.SetPanePosition, { paneId, position }]);
    }
  },
  updateRect(paneId: string, rect: Rect) {
    const sandboxLayoutOverride = sandboxLayoutOverrideBox.get();
    if (sandboxLayoutOverride !== undefined) {
      runInAction(() => {
        sandboxLayoutOverride[paneId].rect = rect;
      });
      return;
    }
    const layoutId = canvasLayoutIdAtom.value;
    if (layoutId === MAGIC_LAYOUT_ID) {
      return;
    }
    if (layoutId !== undefined) {
      canvasDispatch([
        ActionType.SetLayoutPaneRect,
        { layoutId, paneId, rect },
      ]);
    } else {
      canvasDispatch([ActionType.SetPaneRect, { paneId, rect }]);
    }
  },
  updateZ(paneId: string, z: number) {
    const sandboxLayoutOverride = sandboxLayoutOverrideBox.get();
    if (sandboxLayoutOverride !== undefined) {
      runInAction(() => {
        sandboxLayoutOverride[paneId].z = z;
      });
      return;
    }
    const layoutId = canvasLayoutIdAtom.value;
    if (layoutId === MAGIC_LAYOUT_ID) {
      return;
    }
    if (layoutId !== undefined) {
      canvasDispatch([ActionType.SetLayoutPaneZ, { layoutId, paneId, z }]);
    } else {
      canvasDispatch([ActionType.SetPaneZ, { paneId, z }]);
    }
  },
  updateEditorHeight(paneId: string, editorHeight: number | undefined) {
    const sandboxLayoutOverride = sandboxLayoutOverrideBox.get();
    if (sandboxLayoutOverride !== undefined) {
      runInAction(() => {
        sandboxLayoutOverride[paneId].editorHeight = editorHeight;
      });
      return;
    }
    const layoutId = canvasLayoutIdAtom.value;
    if (layoutId === MAGIC_LAYOUT_ID) {
      return;
    }
    if (layoutId !== undefined) {
      canvasDispatch([
        ActionType.SetLayoutPaneEditorHeight,
        { layoutId, paneId, editorHeight },
      ]);
    } else {
      canvasDispatch([
        ActionType.SetPaneEditorHeight,
        { paneId, editorHeight },
      ]);
    }
  },
  setCollapsed(paneId: string, collapsed: boolean) {
    const sandboxLayoutOverride = sandboxLayoutOverrideBox.get();
    if (sandboxLayoutOverride !== undefined) {
      runInAction(() => {
        sandboxLayoutOverride[paneId].collapsed = collapsed;
      });
      return;
    }
    canvasDispatch([
      ActionType.SetPaneCollapse,
      { paneId, collapse: collapsed },
    ]);
  },
};
